import * as React from 'react';
import { Container, Nav } from 'react-bootstrap';
import { Outlet, useLocation, useMatches } from 'react-router-dom';

import { ModalForm } from '@/components/modal-form';
import { PageHeader } from '@/components/pageheader';
import { SearchBar } from '@/components/search-bar';
import { SearchButtonWorkOrders } from '@/components/search-button-workorders';
import { SelectorAPIGroup } from '@/components/selector-api-group';
import { SelectorAPIHelper } from '@/components/selector-api-helper';
import { SelectorDate } from '@/components/selector-date';
import { Match, WorkOrder } from '@/helper/interfaces';
import { useStore } from '@/store';

import { baseURL } from './const';

export function Menu() {
  const { user } = useStore();

  const matches = useMatches() as Match[];
  const isList = matches.at(-1).data?.isList;

  const location = useLocation();
  const isSearch = location.pathname.replace(/\/+$/, '') == '/workorders/search';

  const crumbs = matches
    .filter((match: any) => {
      return Boolean(match.handle?.crumb);
    })
    .map((match: any) => {
      return { name: match.handle?.crumb, link: match.pathname };
    });

  const modal = React.useRef(null);
  const groupHelper = React.useRef(null);
  const [elementSelect, setElementSelect] = React.useState<Partial<WorkOrder>>();

  function createWorkOrder() {
    setElementSelect({});
    modal.current.openModal();
  }

  const modalFood = React.useRef(null);
  function foodReport() {
    modalFood.current.openModal();
  }

  function saveForm() {
    setElementSelect({
      companyId: Number.parseInt(document.querySelector<HTMLInputElement>('input[name="companyId"]').value, 10),
      contactId: Number.parseInt(document.querySelector<HTMLInputElement>('input[name="contactId"]').value, 10),
      projectId: Number.parseInt(document.querySelector<HTMLInputElement>('input[name="projectId"]').value, 10),
      date: document.querySelector<HTMLInputElement>('input[name="date"]').value
    });
  }

  const searchFilters = [
    { name: 'No Invoice', urlParam: 'noInvoice' },
    { name: 'No Job', urlParam: 'noJob' }
  ];

  return (
    <React.Fragment>
      <Container fluid={isList ? true : false}>
        {isList ? (
          <React.Fragment>
            <PageHeader crumbs={crumbs}>Work Orders</PageHeader>
            <Nav>
              {user?.role?.manageWorkOrders && (
                <React.Fragment>
                  <Nav.Link onClick={createWorkOrder}>Add Work Order</Nav.Link>
                  <Nav.Link onClick={foodReport}>Food Report</Nav.Link>
                </React.Fragment>
              )}
              {!isSearch && <SearchBar filters={searchFilters} />}
              <SearchButtonWorkOrders moveRight={isSearch} draggable={true} />
            </Nav>
          </React.Fragment>
        ) : (
          <PageHeader crumbs={crumbs}>Edit Work Order</PageHeader>
        )}
        <Outlet />
      </Container>

      <ModalForm title='Add Work Order' url={baseURL} redirect={baseURL} ref={modal} draggable>
        <SelectorDate valueSelect={elementSelect?.date} />
        <SelectorAPIGroup
          valueSelect={{
            companyId: elementSelect?.companyId,
            contactId: elementSelect?.contactId,
            projectId: elementSelect?.projectId
          }}
          addCompany={() => groupHelper.current.addCompany()}
          addContact={() => groupHelper.current.addContact()}
          linkContact={() => groupHelper.current.linkContact()}
          addProject={() => groupHelper.current.addProject()}
        />
      </ModalForm>

      <ModalForm title='Food Report' url='/reports/food' ref={modalFood} draggable>
        <SelectorDate trackChanges={false} />
      </ModalForm>

      <SelectorAPIHelper
        elementSelect={elementSelect}
        setElementSelect={setElementSelect}
        saveForm={saveForm}
        modal={modal}
        ref={groupHelper}
      />
    </React.Fragment>
  );
}
